import { GridColumnType } from "../../../data/gridColumnType";

export const CertificateIssuanceConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
       colType: GridColumnType.LINK,
       colSettings: {
          isOpenNewTab: false,
          url: "$membershipTaskListLink",
        },
    },
    {
      name: "Cert Number",
      fieldName: "certNumber",
      colType: GridColumnType.Text,
    },

    {
      name: "MUA Status",
      fieldName: "muaStatus",
      colType: GridColumnType.Text,
    },

    {
      name: "Invoice Amount",
      fieldName: "amount",
      colType: GridColumnType.Text,
    },
    {
      name: "Payment Status",
      fieldName: "paymentStatus",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      fieldName: "action",
      allowShort: false,
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
      },
      customAction: [
        {
          name: "Issue",
          // iconName: AppIcons.editIconNew,
          // iconName: AppIcons.copyIcon,
          onViewAction: (data) => {
            alert("called permissions");
          },
        },
      ],
    },
  ],
};
